export default function setTab() {

  /* Elements */
  let tabBtn = document.querySelectorAll('#js-tabBtn a');
  let tabBtnAry = [...tabBtn];
  let tabCont = document.getElementById('js-tabCont');
  let tabContLi = tabCont.querySelectorAll('li');
  let target;

  /* init */
  tabBtnAry.forEach(elm => {
    elm.addEventListener('click', (event) => {
      event.preventDefault();
      // ボタンのカレント
      tabBtnAry.forEach(btn => {
        btn.classList.remove('is-current');
      })
      event.target.classList.add('is-current');
      // クリックボタンの属性を取得
      target = event.target.getAttribute('href');
      target = target.split('#');
      target = target[1];
      // class処理
      Array.from(tabContLi).forEach(list => {
        if (list.classList.contains('is-view')) {
          list.classList.remove('is-view');
        }
      });
      if (tabCont.querySelector(`#${target}`) !== null) {
        tabCont.querySelector(`#${target}`).classList.add('is-view');
      }
    })
  });

}